import { MutationTree } from 'vuex'
import { PermissionState } from './state'
import { PermissionMutationType } from './mutation-types'
import { RouteRecordRaw } from 'vue-router'
import { constantRoutes } from '@/router'

export type SetRoutesPayload = RouteRecordRaw[] | {
  routes?: RouteRecordRaw[];
  dynamicRoutes: RouteRecordRaw[];
  sidebarRoutes: RouteRecordRaw[];
}

export type Mutations<S = PermissionState> = {
  [PermissionMutationType.SET_ROUTES](state: S, payload: SetRoutesPayload): void;
  [PermissionMutationType.SET_PERMISSIONS](state: S, permissions: string[]): void;
}

export const mutations: MutationTree<PermissionState> & Mutations = {
  [PermissionMutationType.SET_ROUTES](state: PermissionState, payload: SetRoutesPayload) {
    if (payload && !Array.isArray(payload) && 'dynamicRoutes' in payload) {
      state.routes = constantRoutes.concat(payload.sidebarRoutes || payload.dynamicRoutes)
      state.dynamicRoutes = payload.dynamicRoutes
      state.sidebarRoutes = payload.sidebarRoutes || []
    } else {
      const routes = Array.isArray(payload) ? payload : []
      state.routes = constantRoutes.concat(routes)
      state.dynamicRoutes = routes
      state.sidebarRoutes = (routes[0] as any)?.children || []
    }
  },

  [PermissionMutationType.SET_PERMISSIONS](state: PermissionState, permissions: string[]) {
    state.permissionsBtn = permissions
  }

}
